// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  src: url('Roboto-Black.ttf');
  font-weight: 900;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-BlackItalic.ttf');
  font-weight: 900;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-Bold.ttf');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-BoldItalic.ttf');
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-Italic.ttf');
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-Light.ttf');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-LightItalic.ttf');
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-Medium.ttf');
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-MediumItalic.ttf');
  font-weight: 500;
  font-style: italic;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-Regular.ttf');
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-Thin.ttf');
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Roboto";
  src: url('Roboto-ThinItalic.ttf');
  font-weight: 100;
  font-style: italic;
}
@font-face {
  font-family: "Roboto Condensed";
  src: url('RobotoCondensed-Bold.ttf');
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "Roboto Condensed";
  src: url('RobotoCondensed-BoldItalic.ttf');
  font-weight: 700;
  font-style: italic;
}
@font-face {
  font-family: "Roboto Condensed";
  src: url('RobotoCondensed-Italic.ttf');
  font-weight: 400;
  font-style: italic;
}
@font-face {
  font-family: "Roboto Condensed";
  src: url('RobotoCondensed-Light.ttf');
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Roboto Condensed";
  src: url('RobotoCondensed-LightItalic.ttf');
  font-weight: 300;
  font-style: italic;
}
@font-face {
  font-family: "Roboto Condensed";
  src: url('RobotoCondensed-Regular.ttf');
  font-weight: 400;
  font-style: normal;
}`, "",{"version":3,"sources":["webpack://./src/theme/fonts.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AACJ;AAEA;EACI,qBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;AAAJ;AAGA;EACI,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AADJ;AAIA;EACI,qBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;AAFJ;AAKA;EACI,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAMA;EACI,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAOA;EACI,qBAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAQA;EACI,qBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AASA;EACI,qBAAA;EACA,mCAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AAUA;EACI,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AARJ;AAWA;EACI,qBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;AATJ;AAYA;EACI,qBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AAaA;EACI,+BAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;AAcA;EACI,+BAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;AAZJ;AAgBA;EACI,+BAAA;EACA,sCAAA;EACA,gBAAA;EACA,kBAAA;AAdJ;AAiBA;EACI,+BAAA;EACA,qCAAA;EACA,gBAAA;EACA,kBAAA;AAfJ;AAkBA;EACI,+BAAA;EACA,2CAAA;EACA,gBAAA;EACA,kBAAA;AAhBJ;AAmBA;EACI,+BAAA;EACA,uCAAA;EACA,gBAAA;EACA,kBAAA;AAjBJ","sourcesContent":["@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Black.ttf');\r\n    font-weight: 900;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-BlackItalic.ttf');\r\n    font-weight: 900;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Bold.ttf');\r\n    font-weight: 700;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-BoldItalic.ttf');\r\n    font-weight: 700;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Italic.ttf');\r\n    font-weight: 400;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Light.ttf');\r\n    font-weight: 300;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-LightItalic.ttf');\r\n    font-weight: 300;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Medium.ttf');\r\n    font-weight: 500;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-MediumItalic.ttf');\r\n    font-weight: 500;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Regular.ttf');\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-Thin.ttf');\r\n    font-weight: 100;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto';\r\n    src: url('../assets/fuentes/Roboto/Roboto-ThinItalic.ttf');\r\n    font-weight: 100;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto Condensed';\r\n    src: url('../assets/fuentes/Roboto_Condensed/RobotoCondensed-Bold.ttf');\r\n    font-weight: 700;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto Condensed';\r\n    src: url('../assets/fuentes/Roboto_Condensed/RobotoCondensed-BoldItalic.ttf');\r\n    font-weight: 700;\r\n    font-style: italic;\r\n}\r\n\r\n\r\n@font-face {\r\n    font-family: 'Roboto Condensed';\r\n    src: url('../assets/fuentes/Roboto_Condensed/RobotoCondensed-Italic.ttf');\r\n    font-weight: 400;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto Condensed';\r\n    src: url('../assets/fuentes/Roboto_Condensed/RobotoCondensed-Light.ttf');\r\n    font-weight: 300;\r\n    font-style: normal;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto Condensed';\r\n    src: url('../assets/fuentes/Roboto_Condensed/RobotoCondensed-LightItalic.ttf');\r\n    font-weight: 300;\r\n    font-style: italic;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Roboto Condensed';\r\n    src: url('../assets/fuentes/Roboto_Condensed/RobotoCondensed-Regular.ttf');\r\n    font-weight: 400;\r\n    font-style: normal;\r\n}\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
